function leastsquaresregression(x, y) {
  //return m and b in the line y = m*x + b that best fits the data x,y
  //nice simple explanation: https://www.mathsisfun.com/data/least-squares-regression.html
  let Sx = 0;
  let Sy = 0;
  let Sxy = 0;
  let Sxx = 0;

  let N = x.length;
  for (let i = 0; i < N; i++) {
    Sx += x[i];
    Sy += y[i];
    Sxx += x[i] * x[i];
    Sxy += x[i] * y[i];
  }

  let m = (N * Sxy - Sx * Sy) / (N * Sxx - Sx * Sx);
  let b = (Sy - m * Sx) / N;
  // fitted_y = m*some_x + b;
  return [m, b];
}

export function trend(years, emissions, firstyear, lastyear) {
  //return yearly change in emissions and what that means as a percentage (with the fitted line as reference)
  //example:
  //trend(data.years, data.municipality.emissions["_sum"]["_sum"], 2015, 2017)
  //trend(data.years, data.municipality.emissions["Arbetsmaskiner"]["_sum"], 2015, 2017)
  let n = years.indexOf(firstyear);
  let N = years.indexOf(lastyear);

  let x = years.slice(n, N + 1);
  let y = emissions.slice(n, N + 1);
  let [m, b] = leastsquaresregression(x, y);

  //expected percentage change between lastyear and lastyear+1
  let p = (100 * m) / (m * lastyear + b);

  //argument for fixed percent scenario, which is
  //reduction fraction in terms of emission[lastyear])
  //0.01 would mean reduce yearly by 1%
  //let p = -m / (m * lastyear + b);
  return [m, p];
}
